import React, { useEffect } from "react";

import { FormProvider } from "react-hook-form";
import PropTypes from "prop-types";

// This component is similar to Form.js. The difference is that in this one we received via props the methods from the Hook useForm, so then we can use that hook from the parent component. That hook is provided in react-hook-form library and allow us to do several things https://react-hook-form.com/api/useform/ 

const Form = ({
    onSubmit,
    defaultValues = {},
    mode = "onBlur",
    children,
    methods,
    ...rest
}) => {

    useEffect(() => {
        if (defaultValues)
            methods.reset(defaultValues);
        // Intentionally mount-only: adding defaultValues/methods would reset the form
        // on every parent re-render, wiping user input mid-edit.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FormProvider {...methods} >
            <form
                noValidate
                {...rest}
                onSubmit={methods.handleSubmit(onSubmit)}
                onReset={() => {
                    methods.reset();
                }}
            >
                {children}
            </form>
        </FormProvider>
    );
};

Form.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    defaultValues: PropTypes.object,
    mode: PropTypes.string,
    children: PropTypes.node,
    methods: PropTypes.object.isRequired,
};

export default Form;
